import React, { useEffect, useRef } from 'react';

const StripePaymentModal = ({
  isOpen,
  onClose,
  buyButtonId,
  publishableKey,
  paymentTitle = 'Upgrade Now',
  paymentMessage = 'Support the project and unlock premium features.'
}) => {
  const containerRef = useRef(null);

  // Load script if needed
  useEffect(() => {
    if (isOpen && !document.querySelector('#stripe-buy-button-script')) {
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/buy-button.js';
      script.async = true;
      script.id = 'stripe-buy-button-script';
      document.body.appendChild(script);
    }
  }, [isOpen]);

  // Inject button HTML
  useEffect(() => {
    if (isOpen && containerRef.current && buyButtonId && publishableKey) {
      containerRef.current.innerHTML = `
        <stripe-buy-button
          buy-button-id="${buyButtonId}"
          publishable-key="${publishableKey}">
        </stripe-buy-button>
      `;
    }
  }, [isOpen, buyButtonId, publishableKey]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-6 w-80 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
        >
          ×
        </button>
        <h3 className="text-lg font-semibold text-gray-800 mb-2">{paymentTitle}</h3>
        <p className="text-sm text-gray-600 mb-4">{paymentMessage}</p>
        <div ref={containerRef}></div>
      </div>
    </div>
  );
};

export default StripePaymentModal;
